export const participantsList = [
  {
      "firstname": "Dawid",
      "lastname": "Niedojadło",
      "displayName": "Dawid Niedojadło",
      "email": "dawid.niedojadlo@innoenergy.com"
  },
  {
      "firstname": "Ákos",
      "lastname": "Dervalics",
      "displayName": "Ákos Dervalics",
      "email": "akos.dervalics@gmail.com",
      "country": "Hungary",
      "category": "Investor",
      "company": "InnoEnergy HUB"
  },
  {
      "firstname": "Tomas",
      "lastname": "Kindl",
      "displayName": "Tomas Kindl",
      "email": "tomas.kindl@airventures.eu",
      "country": "Czech Republic",
      "category": "Investor",
      "company": "Air Ventures"
  },
  {
      "firstname": "Paweł",
      "lastname": "Poneta",
      "displayName": "Paweł Poneta",
      "email": "pawel.poneta@tauron.pl",
      "country": "Poland",
      "category": "Corporate",
      "company": "TAURON Polska Energia S.A."
  },
  {
      "firstname": "J",
      "lastname": "Semrau",
      "displayName": "J Semrau",
      "email": "NXMC@LIVE.COM",
      "country": "United States",
      "category": "Start-up or scale-up",
      "company": "NXMC"
  },
  {
      "firstname": "Roger",
      "lastname": "Presto",
      "displayName": "Roger Presto",
      "email": "tresoil.biofuels@gmail.com",
      "country": "Romania",
      "category": "Start-up or scale-up",
      "company": "Tresoil Biofuels SRL"
  },
  {
      "firstname": "Basar",
      "lastname": "Kaya",
      "displayName": "Basar Kaya",
      "email": "basarkaya@sabanciuniv.edu",
      "country": "Turkey",
      "category": "University",
      "company": "Sabanci University"
  },
  {
      "firstname": "Janis",
      "lastname": "Siklis",
      "displayName": "Janis Siklis",
      "email": "janis@balticsalesagency.com",
      "country": "Latvia",
      "category": "Investor",
      "company": "Baltic Sales Agency /Investor &  Potential Tech Products reseller"
  },
  {
      "firstname": "Žilvinas",
      "lastname": "Danys",
      "displayName": "Žilvinas Danys",
      "email": "zilvinas.danys@enmin.lt",
      "category": "Public organisation",
      "company": "Ministry of Energy"
  },
  {
      "firstname": "Asli",
      "lastname": "Isildar",
      "displayName": "Asli Isildar",
      "email": "isildar@sabanciuniv.edu",
      "country": "Turkey",
      "category": "University",
      "company": "InnoEnergy Hub Turkey - Inovent"
  },
  {
      "firstname": "Mirela",
      "lastname": "Ivanov",
      "displayName": "Mirela Ivanov",
      "email": "mirelaivanov@gmail.com",
      "country": "Romania",
      "category": "Corporate",
      "company": "KPMG"
  },
  {
      "firstname": "Marcin",
      "lastname": "Dolata",
      "displayName": "Marcin Dolata",
      "email": "marcin.dolata@easysolar-app.com",
      "country": "Polan",
      "category": "Start-up or scale-up",
      "company": "EasySolar"
  },
  {
      "firstname": "Tumay",
      "lastname": "Solak",
      "displayName": "Tumay Solak",
      "email": "tumaysolak@gmail.com",
      "country": "Turkey",
      "category": "Corporate",
      "company": "Enerjisa Üretim"
  },
  {
      "firstname": "Eli",
      "lastname": "Shtereva",
      "displayName": "Eli Shtereva",
      "email": "eli@cleantech.bg",
      "country": "Bulgaria",
      "category": "Corporate",
      "company": "Cleantech Bulgaria"
  },
  {
      "firstname": "Selen",
      "lastname": "Inal",
      "displayName": "Selen Inal",
      "email": "selen.inal@turseff.org",
      "country": "Turkey",
      "category": "Corporate",
      "company": "TurSEFF - Turkey Sustainable Energy Financing Facility"
  },
  {
      "firstname": "Miro",
      "lastname": "Hachlinec",
      "displayName": "Miro Hachlinec",
      "email": "miro@beit.io",
      "category": "Start-up or scale-up",
      "company": "BeiT"
  },
  {
      "firstname": "Annamária",
      "lastname": "Virág",
      "displayName": "Annamária Virág",
      "email": "annamaria.virag@climate-kic.org",
      "country": "Hungary",
      "category": "Public organisation",
      "company": "EIT Climate-KIC"
  },
  {
      "firstname": "Askold",
      "lastname": "K",
      "displayName": "Askold K",
      "email": "askold.klyus+edu@gmail.com",
      "category": "Start-up or scale-up",
      "company": "RN"
  },
  {
      "firstname": "Duygu",
      "lastname": "Cagman",
      "displayName": "Duygu Cagman",
      "email": "duygucagman@gmail.com",
      "category": "Students and learners",
      "company": "Escp business school"
  },
  {
      "firstname": "Ferenc",
      "lastname": "Kis",
      "displayName": "Ferenc Kis",
      "email": "ferenc.kis@gmail.com",
      "country": "Hungary",
      "category": "Start-up or scale-up",
      "company": "Solar PV Hungary"
  },
  {
      "firstname": "Andrej",
      "lastname": "Juris",
      "displayName": "Andrej Juris",
      "email": "andrej.juris@yahoo.com",
      "country": "Slovakia",
      "category": "Corporate",
      "company": "ESAdv"
  },
  {
      "firstname": "Atılay",
      "lastname": "BAYAT",
      "displayName": "Atılay BAYAT",
      "email": "atilaybayat@gmail.com",
      "country": "Turkey",
      "category": "Students and learners",
      "company": "effe"
  },
  {
      "firstname": "Ali",
      "lastname": "Konü",
      "displayName": "Ali Konü",
      "email": "ali_konu_001@hotmail.com",
      "category": "Start-up or scale-up",
      "company": "Enerjisa"
  },
  {
      "firstname": "OKTAY",
      "lastname": "YILDIRIM",
      "displayName": "OKTAY YILDIRIM",
      "email": "oktayy2134@gmail.com",
      "country": "Turkey",
      "category": "University",
      "company": "Fresh Graduated Electrical Engineer(Renewable Energy Field)"
  },
  {
      "firstname": "Natalia",
      "lastname": "Stec",
      "displayName": "Natalia Stec",
      "email": "natalia.stec@innoenergy.com",
      "country": "Polska",
      "category": "Investor",
      "company": "InnoEnergy Central Europe"
  },
  {
      "firstname": "Lana",
      "lastname": "Ugrcic",
      "displayName": "Lana Ugrcic",
      "email": "lana.ugrcic@gmail.com",
      "category": "University",
      "company": "EFST"
  },
  {
      "firstname": "Michal",
      "lastname": "Mravec",
      "displayName": "Michal Mravec",
      "email": "michal.mravec@invencapital.cz",
      "country": "Czech Republic",
      "category": "Investor",
      "company": "Inven Capital"
  },
  {
      "firstname": "Wallace",
      "lastname": "Green",
      "displayName": "Wallace Green",
      "email": "mwallacegreen@gmail.com",
      "country": "Czechia",
      "category": "Investor",
      "company": "Actnow Ventures"
  },
  {
      "firstname": "Bilge",
      "lastname": "Celebioglu",
      "displayName": "Bilge Celebioglu",
      "email": "bilge.celebioglu@enerjisa.com",
      "country": "Turkey",
      "category": "Corporate",
      "company": "Enerjisa"
  },
  {
      "firstname": "Katka",
      "lastname": "Krosnar",
      "displayName": "Katka Krosnar",
      "email": "katka.krosnar@mergermarket.com",
      "country": "Czech Republic",
      "category": "Press and media",
      "company": "Mergermarket"
  },
  {
      "firstname": "Osman",
      "lastname": "Kale",
      "displayName": "Osman Kale",
      "email": "osmankale@enther.com.tr",
      "country": "Turkey",
      "category": "Corporate",
      "company": "Enther Energy"
  },
  {
      "firstname": "Aleksandar",
      "lastname": "Arnaut",
      "displayName": "Aleksandar Arnaut",
      "email": "aleksandar.arnaut@startit.rs",
      "country": "Serbia",
      "category": "Corporate",
      "company": "Startit"
  },
  {
      "firstname": "Aris",
      "lastname": "Kalogeropoulos",
      "displayName": "Aris Kalogeropoulos",
      "email": "akalogeropoulos@gmail.com",
      "category": "Corporate",
      "company": "Vodafone Innovus"
  },
  {
      "firstname": "Paris",
      "lastname": "Rallis",
      "displayName": "Paris Rallis",
      "email": "paris.rallis@fujifilm.com",
      "country": "Netherlands",
      "category": "Corporate",
      "company": "FUJIFILM Manufacturing Europe"
  },
  {
      "firstname": "Oksana",
      "lastname": "Dybkina",
      "displayName": "Oksana Dybkina",
      "email": "DybkinaOV@dtek.com",
      "country": "Ukraine",
      "category": "Corporate",
      "company": "Dtek"
  },
  {
      "firstname": "Tamás",
      "lastname": "Megyeri",
      "displayName": "Tamás Megyeri",
      "email": "megyeri.tamas@videoton.hu",
      "country": "Magyarország",
      "category": "Corporate",
      "company": "Videoton Holding ZRt."
  },
  {
      "firstname": "Douglas",
      "lastname": "Wong",
      "displayName": "Douglas Wong",
      "email": "doug.w@blackfire.cz",
      "country": "Czech Republic",
      "category": "Investor",
      "company": "Blackfire"
  },
  {
      "firstname": "Jan",
      "lastname": "Misovic",
      "displayName": "Jan Misovic",
      "email": "jan.misovic@ceegcc.com",
      "country": "Slovakia",
      "category": "Students and learners",
      "company": "CEEGCC"
  },
  {
      "firstname": "Miroslav",
      "lastname": "Mulica",
      "displayName": "Miroslav Mulica",
      "email": "mulica@axcap.eu",
      "country": "Slovakia",
      "category": "Corporate",
      "company": "Axelero Capital Advisors, j. s. a., skrátene: AxCap j. s. a."
  },
  {
      "firstname": "Rabia Şeyma",
      "lastname": "Yılmaz",
      "displayName": "Rabia Şeyma Yılmaz",
      "email": "seyma.yilmaz@inavitas.com",
      "country": "Turkey",
      "category": "Research center",
      "company": "inavitas"
  },
  {
      "firstname": "Patrik",
      "lastname": "Kurilla",
      "displayName": "Patrik Kurilla",
      "email": "patrik.kurilla@inobat.eu",
      "category": "Start-up or scale-up",
      "company": "InoBat"
  },
  {
      "firstname": "Aziz",
      "lastname": "Hazizi",
      "displayName": "Aziz Hazizi",
      "email": "aziz7azizi@gmail.com",
      "country": "Malaysia",
      "category": "Start-up or scale-up",
      "company": "E-Fast Solutions"
  },
  {
      "firstname": "Jürgen",
      "lastname": "Ludwig",
      "displayName": "Jürgen Ludwig",
      "email": "juergen.ludwig@result-counts.de",
      "country": "Germany",
      "category": "Start-up or scale-up",
      "company": "Result Counts GmbH"
  },
  {
      "firstname": "Sotiris",
      "lastname": "Petrakides",
      "displayName": "Sotiris Petrakides",
      "email": "s.petrakides@inomob.eu",
      "country": "Cyprus",
      "category": "Start-up or scale-up",
      "company": "InoMob"
  },
  {
      "firstname": "Ivan",
      "lastname": "Bozhikin",
      "displayName": "Ivan Bozhikin",
      "email": "bozhikin@gmail.com",
      "country": "BULGARIA",
      "category": "University",
      "company": "UNWE"
  },
  {
      "firstname": "Sebastian",
      "lastname": "Sulma",
      "displayName": "Sebastian Sulma",
      "email": "biuro@sulmaisulma.pl",
      "country": "Poland",
      "category": "Investor",
      "company": "Sulma & Sulma"
  },
  {
      "firstname": "Swapp!",
      "lastname": "Sarapata",
      "displayName": "Swapp! Sarapata",
      "email": "andrew@swapp.zone",
      "country": "Poland",
      "category": "Start-up or scale-up",
      "company": "Swapp"
  },
  {
      "firstname": "B. KORAY",
      "lastname": "TUNÇALP",
      "displayName": "B. KORAY TUNÇALP",
      "email": "koraytuncalp@halic.edu.tr",
      "country": "Turkey",
      "category": "University",
      "company": "Haliç University"
  },
  {
      "firstname": "József",
      "lastname": "Kránitz",
      "displayName": "József Kránitz",
      "email": "jozsef@reverto-global.hu",
      "country": "Hungary",
      "category": "Research center",
      "company": "Reverto-Global Llc"
  },
  {
      "firstname": "Patrik",
      "lastname": "Krizansky",
      "displayName": "Patrik Krizansky",
      "email": "krizansky@espio.eu",
      "country": "Slovakia",
      "category": "Start-up or scale-up",
      "company": "Espio"
  },
  {
      "firstname": "Petar",
      "lastname": "Gusić",
      "displayName": "Petar Gusić",
      "email": "petar.gusic@gmail.com",
      "country": "Estonia",
      "category": "Start-up or scale-up",
      "company": "DeseiRose OÜ"
  },
  {
      "firstname": "Michal",
      "lastname": "Pychtin",
      "displayName": "Michal Pychtin",
      "email": "michal.pychtin@oriwin.eu",
      "country": "Slovakia",
      "category": "Start-up or scale-up",
      "company": "ORIWIN"
  },
  {
      "firstname": "Janos",
      "lastname": "Bognar",
      "displayName": "Janos Bognar",
      "email": "bognar.janos@aut.videoton.hu",
      "country": "Hungary",
      "category": "Corporate",
      "company": "Videoton Autoelektronika"
  },
  {
      "firstname": "Ipek",
      "lastname": "Guralp",
      "displayName": "Ipek Guralp",
      "email": "ipekguralp@limak.com.tr",
      "country": "Turkey",
      "category": "Corporate",
      "company": "Limak"
  },
  {
      "firstname": "Maja",
      "lastname": "Zivanovic",
      "displayName": "Maja Zivanovic",
      "email": "maja.zivanovic@cms-rrh.com",
      "country": "Serbia",
      "category": "Corporate",
      "company": "CMS"
  },
  {
      "firstname": "Sabina",
      "lastname": "Gros",
      "displayName": "Sabina Gros",
      "email": "sabina.gros@bpt.si",
      "category": "Investor",
      "company": "BPT d.o.o."
  },
  {
      "firstname": "MELTEM",
      "lastname": "ALTINAY",
      "displayName": "MELTEM ALTINAY",
      "email": "altinayameltem@yahoo.com",
      "country": "Türkiye",
      "category": "Students and learners",
      "company": "optimal aluminyum"
  },
  {
      "firstname": "Stanislaw",
      "lastname": "Tokarski",
      "displayName": "Stanislaw Tokarski",
      "email": "stanislaw@tokarski.jaw.pl",
      "country": "Poland",
      "category": "Research center",
      "company": "AGH"
  },
  {
      "firstname": "Emanuel",
      "lastname": "Topor",
      "displayName": "Emanuel Topor",
      "email": "office.green2go@gmail.com",
      "country": "Romania",
      "category": "Start-up or scale-up",
      "company": "Green-2Go"
  },
  {
      "firstname": "Alper",
      "lastname": "Terciyanli",
      "displayName": "Alper Terciyanli",
      "email": "alper.terciyanli@endoks.com",
      "country": "Turkey",
      "category": "Investor",
      "company": "General Manager"
  },
  {
      "firstname": "Veronika",
      "lastname": "Froncova",
      "displayName": "Veronika Froncova",
      "email": "veronika@mileus.com",
      "country": "Czechia",
      "category": "Start-up or scale-up",
      "company": "Mileus"
  },
  {
      "firstname": "Kristýna",
      "lastname": "Machová",
      "displayName": "Kristýna Machová",
      "email": "kristyna.machova@invencapital.cz",
      "country": "Czech Republic",
      "category": "Investor",
      "company": "Inven Capital"
  },
  {
      "firstname": "Chaichana",
      "lastname": "Tosuwancharoen",
      "displayName": "Chaichana Tosuwancharoen",
      "email": "ball.tosu@gmail.com",
      "country": "Hungary",
      "category": "Students and learners",
      "company": "BMe"
  },
  {
      "firstname": "Volkan",
      "lastname": "Aktürk",
      "displayName": "Volkan Aktürk",
      "email": "vakturk@sankoenerji.com.tr",
      "category": "Investor",
      "company": "Sanko Enerji"
  },
  {
      "firstname": "Ezgi",
      "lastname": "Aslan",
      "displayName": "Ezgi Aslan",
      "email": "ezgi.aslan@aydemenerji.com.tr",
      "country": "Turkey",
      "category": "Investor",
      "company": "Ayfem Holding"
  },
  {
      "firstname": "Emanuele",
      "lastname": "Volpe",
      "displayName": "Emanuele Volpe",
      "email": "VolpeE@dtek.com",
      "country": "Ukraine",
      "category": "Corporate",
      "company": "DTEK"
  },
  {
      "firstname": "Dario",
      "lastname": "Petrlic",
      "displayName": "Dario Petrlic",
      "email": "dpetrlic@gmail.com",
      "country": "Croatia",
      "category": "Start-up or scale-up",
      "company": "AI Tech"
  },
  {
      "firstname": "Beata",
      "lastname": "Szoboszlai",
      "displayName": "Beata Szoboszlai",
      "email": "bszoboszlai@mvm.hu",
      "category": "Corporate",
      "company": "MVM"
  },
  {
      "firstname": "Özge",
      "lastname": "Kale",
      "displayName": "Özge Kale",
      "email": "okale@enther.com.tr",
      "country": "Turkiye",
      "category": "Investor",
      "company": "Enther Energy"
  },
  {
      "firstname": "Melis",
      "lastname": "Ertugrul",
      "displayName": "Melis Ertugrul",
      "email": "mzeynep.ertugrul@gmail.com",
      "country": "Turkiye",
      "category": "University",
      "company": "BSH"
  },
  {
      "firstname": "Karlis",
      "lastname": "Gicevskis",
      "displayName": "Karlis Gicevskis",
      "email": "Karlis.Gicevskis@latvenergo.lv",
      "country": "Latvia",
      "category": "Corporate",
      "company": "Latvenergo"
  },
  {
      "firstname": "Gaye",
      "lastname": "Kanalti Bas",
      "displayName": "Gaye Kanalti Bas",
      "email": "gayekanalti@unvergroup.com",
      "country": "Turkey",
      "category": "Corporate",
      "company": "Unver Group"
  },
  {
      "firstname": "Sevgi",
      "lastname": "Demirkale",
      "displayName": "Sevgi Demirkale",
      "email": "sevgi.demirkale@sabanciuniv.edu",
      "country": "Turkey",
      "category": "University",
      "company": "Sabancı University"
  },
  {
      "firstname": "Jakab",
      "lastname": "Puskás",
      "displayName": "Jakab Puskás",
      "email": "puskas.jakab@vtep.videoton.hu",
      "country": "Hungary",
      "category": "Corporate",
      "company": "Videoton Elektro-PLAST kft."
  },
  {
      "firstname": "Akay",
      "lastname": "Beyazay",
      "displayName": "Akay Beyazay",
      "email": "akaybeyazay@gmail.com",
      "country": "Turkey",
      "category": "Investor",
      "company": "BUBA Ventures"
  },
  {
      "firstname": "Tomislav",
      "lastname": "Durica",
      "displayName": "Tomislav Durica",
      "email": "tdjurica@hotmail.com",
      "country": "Croatia",
      "category": "Corporate",
      "company": "Ferrero"
  },
  {
      "firstname": "Paul",
      "lastname": "Smith",
      "displayName": "Paul Smith",
      "email": "pljsmth@gmail.com",
      "country": "Greece",
      "category": "Corporate",
      "company": "METKA"
  },
  {
      "firstname": "Elitsa",
      "lastname": "Petkova",
      "displayName": "Elitsa Petkova",
      "email": "elitsa@cleantech.bg",
      "category": "Corporate",
      "company": "Cleantech Bulgaria"
  },
  {
      "firstname": "Agata",
      "lastname": "Mazepus",
      "displayName": "Agata Mazepus",
      "email": "agata.mazepus@cz.ey.com",
      "country": "Czechia",
      "category": "Corporate",
      "company": "EY"
  },
  {
      "firstname": "Daumantas",
      "lastname": "Kerezis",
      "displayName": "Daumantas Kerezis",
      "email": "daumantas.kerezis@enmin.lt",
      "country": "Lithuania",
      "category": "Public organisation",
      "company": "Ministry of Energy of the Republic of Lithuania"
  },
  {
      "firstname": "Anna",
      "lastname": "Vosečková",
      "displayName": "Anna Vosečková",
      "email": "voseckova@tc.cz",
      "country": "Czechia",
      "category": "Research center",
      "company": "Technology Centre CAS"
  },
  {
      "firstname": "Daniel",
      "lastname": "Pintilie",
      "displayName": "Daniel Pintilie",
      "email": "daniel@watto.eu",
      "country": "Romania",
      "category": "Start-up or scale-up",
      "company": "Watto Stations"
  },
  {
      "firstname": "Murat Gokhan",
      "lastname": "Eskin",
      "displayName": "Murat Gokhan Eskin",
      "email": "mgeskin@sabanciuniv.edu",
      "category": "Start-up or scale-up",
      "company": "MightyCell"
  },
  {
      "firstname": "Eva",
      "lastname": "Bulas",
      "displayName": "Eva Bulas",
      "email": "BulasE@state.gov",
      "category": "Public organisation",
      "company": "U.S. Embassy in Bratislava"
  },
  {
      "firstname": "Jan",
      "lastname": "Purkrabek",
      "displayName": "Jan Purkrabek",
      "email": "jan.purkrabek@mastercard.com",
      "country": "CZ",
      "category": "Corporate",
      "company": "Mastercard"
  },
  {
      "firstname": "Damian",
      "lastname": "Wielechowski",
      "displayName": "Damian Wielechowski",
      "email": "damian.wielechowski@speedupgroup.com",
      "country": "Poland",
      "category": "Investor",
      "company": "SpeedUp VC Group"
  },
  {
      "firstname": "Muhammet",
      "lastname": "Armutlu",
      "displayName": "Muhammet Armutlu",
      "email": "muhammet.armutlu@collectivespark.com",
      "country": "Turkey",
      "category": "Investor",
      "company": "Collective Spark"
  },
  {
      "firstname": "Jan",
      "lastname": "Kubalik",
      "displayName": "Jan Kubalik",
      "email": "jan.kubalik@dex-ic.com",
      "country": "Czechia",
      "category": "Research center",
      "company": "DEX Innovation Centre"
  },
  {
      "firstname": "mohammed",
      "lastname": "awal",
      "displayName": "mohammed awal",
      "email": "mohd.awal@gmail.com",
      "country": "bahrain",
      "category": "Press and media",
      "company": "Journalism"
  },
  {
      "firstname": "Tomasz",
      "lastname": "Rodziewicz",
      "displayName": "Tomasz Rodziewicz",
      "email": "tomasz.rodziewicz@tauron-dystrybucja.pl",
      "country": "Poland",
      "category": "Corporate",
      "company": "TAURON"
  },
  {
      "firstname": "Angelica",
      "lastname": "Chow",
      "displayName": "Angelica Chow",
      "email": "achow611@gmail.com",
      "country": "United States",
      "category": "Corporate",
      "company": "Mazzetti"
  },
  {
      "firstname": "Mateusz",
      "lastname": "Oziębłowski",
      "displayName": "Mateusz Oziębłowski",
      "email": "m.ozieblowski@sulmaisulma.pl",
      "category": "Corporate",
      "company": "Sulma & Sulma"
  },
  {
      "firstname": "Maciej",
      "lastname": "Majewski",
      "displayName": "Maciej Majewski",
      "email": "maciek@accelpoint.pl",
      "category": "Investor",
      "company": "Accelpoint"
  },
  {
      "firstname": "Dominika",
      "lastname": "Bucová",
      "displayName": "Dominika Bucová",
      "email": "dominika.bucova@dex-ic.com",
      "country": "Czechia",
      "category": "Research center",
      "company": "DEX Innovation Centre - InnoEnergy Hub Czechia"
  },
  {
      "firstname": "Avinash",
      "lastname": "Kumar",
      "displayName": "Avinash Kumar",
      "email": "slg.avinashku@gmail.com",
      "country": "Germany",
      "category": "University",
      "company": "Technical University of Munich"
  },
  {
      "firstname": "Anusha",
      "lastname": "Sheth",
      "displayName": "Anusha Sheth",
      "email": "anushasheth@gmail.com",
      "country": "India",
      "category": "Corporate",
      "company": "Bosch"
  },
  {
      "firstname": "Damir",
      "lastname": "Sever",
      "displayName": "Damir Sever",
      "email": "s.damir7@gmail.com",
      "country": "Croatia",
      "category": "Start-up or scale-up",
      "company": "Ariser"
  },
  {
      "firstname": "Trishna",
      "lastname": "Kammili",
      "displayName": "Trishna Kammili",
      "email": "tkammili@r-gds.fr",
      "country": "France",
      "category": "Corporate",
      "company": "R-GDS"
  },
  {
      "firstname": "Zoltan",
      "lastname": "Csipai",
      "displayName": "Zoltan Csipai",
      "email": "zoltan.csipai@gmail.com",
      "country": "Hungary",
      "category": "Start-up or scale-up",
      "company": "Nanobubbles Europe"
  },
  {
      "firstname": "Yi",
      "lastname": "Chow",
      "displayName": "Yi Chow",
      "email": "yijean.chow@innogy.com",
      "category": "Investor",
      "company": "innogy New Ventures"
  },
  {
      "firstname": "ESTEFANIA",
      "lastname": "BEJARANO",
      "displayName": "ESTEFANIA BEJARANO",
      "email": "bc.estefania@gmail.com",
      "country": "Colombia",
      "category": "Public organisation",
      "company": "UPME"
  },
  {
      "firstname": "Christian",
      "lastname": "Orner",
      "displayName": "Christian Orner",
      "email": "christianorner8@gmail.com",
      "country": "Czech republic",
      "category": "Corporate",
      "company": "Ricardo"
  },
  {
      "firstname": "Heleri",
      "lastname": "Holm",
      "displayName": "Heleri Holm",
      "email": "heleri@tehnopol.ee",
      "country": "Estonia",
      "category": "Public organisation",
      "company": "Tallinn Science Park Tehnopol"
  },
  {
      "firstname": "Anne-Liisa",
      "lastname": "Elbrecht",
      "displayName": "Anne-Liisa Elbrecht",
      "email": "liisa@tehnopol.ee",
      "country": "Estonia",
      "category": "Start-up or scale-up",
      "company": "SA Tallinna Teaduspark Tehnopol"
  },
  {
      "firstname": "Lisbeth",
      "lastname": "Roos",
      "displayName": "Lisbeth Roos",
      "email": "lisbeth@tehnopol.ee",
      "country": "Estonia",
      "category": "Public organisation",
      "company": "Tehnopol"
  },
  {
      "firstname": "Kristi",
      "lastname": "Jõeäär",
      "displayName": "Kristi Jõeäär",
      "email": "kristi.joeaar@tehnopol.ee",
      "category": "Public organisation",
      "company": "Tehnopol"
  },
  {
      "firstname": "Kristiina",
      "lastname": "Libe",
      "displayName": "Kristiina Libe",
      "email": "kristiina.libe@tehnopol.ee",
      "country": "Estonia",
      "category": "Corporate",
      "company": "Tehnopol"
  },
  {
      "firstname": "BATUHAN",
      "lastname": "BAYBALI",
      "displayName": "BATUHAN BAYBALI",
      "email": "batuhan@fplus.ventures",
      "country": "Turkey",
      "category": "Investor",
      "company": "F+ Ventures"
  },
  {
      "firstname": "Snjezana",
      "lastname": "JOVANOVIC-FINIDORI",
      "displayName": "Snjezana JOVANOVIC-FINIDORI",
      "email": "jsnejana@yahoo.fr",
      "country": "France",
      "category": "Start-up or scale-up",
      "company": "HODLNG"
  },
  {
      "firstname": "Triin",
      "lastname": "Ilves",
      "displayName": "Triin Ilves",
      "email": "triin@tehnopol.ee",
      "country": "Estonia",
      "category": "Public organisation",
      "company": "Tehnopol"
  },
  {
      "firstname": "Victoria",
      "lastname": "Katsarou",
      "displayName": "Victoria Katsarou",
      "email": "katsarou@kinno.eu",
      "country": "Greece",
      "category": "Corporate",
      "company": "KiNNO Consultants Ltd (IE HUB GREECE)"
  },
  {
      "firstname": "Artur",
      "lastname": "Thernesz",
      "displayName": "Artur Thernesz",
      "email": "athernesz@amei.hu",
      "country": "Hungary",
      "category": "Investor",
      "company": "AMEI Zrt."
  },
  {
      "firstname": "Mihkel",
      "lastname": "Tedremaa",
      "displayName": "Mihkel Tedremaa",
      "email": "mihkel@superhands.ee",
      "country": "Eesti",
      "category": "Start-up or scale-up",
      "company": "Superhands OÜ"
  },
  {
      "firstname": "Jevgeni",
      "lastname": "Širai",
      "displayName": "Jevgeni Širai",
      "email": "jevgeni.shirai@gmail.com",
      "category": "Start-up or scale-up",
      "company": "Woola"
  },
  {
      "firstname": "Elis",
      "lastname": "Tootsman",
      "displayName": "Elis Tootsman",
      "email": "elis@accelerateestonia.ee",
      "category": "Corporate",
      "company": "Accelerate Estonia"
  },
  {
      "firstname": "Jithin",
      "lastname": "Jomy",
      "displayName": "Jithin Jomy",
      "email": "jithinjomy@gmail.com",
      "country": "India",
      "category": "Students and learners",
      "company": "Indian oil corporation limited"
  },
  {
      "firstname": "Ana",
      "lastname": "Carević",
      "displayName": "Ana Carević",
      "email": "ana.carevic@innoenergy.com",
      "country": "Croatia",
      "category": "Corporate",
      "company": "Optimizacija"
  },
  {
      "firstname": "Rafał",
      "lastname": "Ćwiertnia",
      "displayName": "Rafał Ćwiertnia",
      "email": "rafal@wolvessummit.com",
      "country": "Polska",
      "category": "Investor",
      "company": "Wolves Summit"
  },
  {
      "firstname": "Zuzana",
      "lastname": "Matuščáková",
      "displayName": "Zuzana Matuščáková",
      "email": "zuzana.matuscakova@forbes.sk",
      "country": "Slovakia",
      "category": "Press and media",
      "company": "Forbes"
  },
  {
      "firstname": "Ragmar",
      "lastname": "Saksing",
      "displayName": "Ragmar Saksing",
      "email": "ragmar@tehnopol.ee",
      "country": "Estonia",
      "category": "Public organisation",
      "company": "TALLINN SCIENCE PARK TEHNOPOL"
  },
  {
      "firstname": "Sanja",
      "lastname": "Hajdukovic",
      "displayName": "Sanja Hajdukovic",
      "email": "sanja.hajdukovic@smartcat.io",
      "country": "Serbia",
      "category": "Start-up or scale-up",
      "company": "SmartCat doo"
  },
  {
      "firstname": "robert",
      "lastname": "slavec",
      "displayName": "robert slavec",
      "email": "robert.slavec@gmail.com",
      "country": "Slovenia",
      "category": "Start-up or scale-up",
      "company": "MYWATER d.o.o."
  },
  {
      "firstname": "Kamen",
      "lastname": "Zlatanov",
      "displayName": "Kamen Zlatanov",
      "email": "editors@todaytech.eu",
      "country": "Bulgaria",
      "category": "Press and media",
      "company": "Today tech"
  },
  {
      "firstname": "Md. Reas",
      "lastname": "Chowdhury",
      "displayName": "Md. Reas Chowdhury",
      "email": "reaschowdhury@gmail.com",
      "country": "Bangladesh",
      "category": "Investor",
      "company": "Marhaba Spinning Mill Ltd."
  },
  {
      "firstname": "Marcel",
      "lastname": "Hanečák",
      "displayName": "Marcel Hanečák",
      "email": "marcel.hanecak@zsdis.sk",
      "country": "Slovakia",
      "category": "Investor",
      "company": "Západoslovenká distribučná, a.s."
  },
  {
      "firstname": "Michal",
      "lastname": "Mackowiak",
      "displayName": "Michal Mackowiak",
      "email": "michal.mackowiak@rafako.pl",
      "country": "POLAND",
      "category": "Corporate",
      "company": "RAFAKO SA"
  },
  {
      "firstname": "Reinis",
      "lastname": "Spunde",
      "displayName": "Reinis Spunde",
      "email": "rs@catalyco.eu",
      "country": "Latvija",
      "category": "Start-up or scale-up",
      "company": "Catalyco SIA"
  },
  {
      "firstname": "Orkunt",
      "lastname": "Yozgat",
      "displayName": "Orkunt Yozgat",
      "email": "yozgato@gmail.com",
      "country": "Turkey",
      "category": "Start-up or scale-up",
      "company": "Blink energy"
  },
  {
      "firstname": "Lucie",
      "lastname": "Noswitz",
      "displayName": "Lucie Noswitz",
      "email": "lucie.noswitz@dex-ic.com",
      "country": "The Czech Republic",
      "category": "Corporate",
      "company": "DEXIC"
  },
  {
      "firstname": "Michal",
      "lastname": "Štefan",
      "displayName": "Michal Štefan",
      "email": "michal.stefan@dex-ic.com",
      "country": "Czech Republic",
      "category": "Research center",
      "company": "DEX Innovation Centre"
  },
  {
      "firstname": "Marzena",
      "lastname": "Bielecka",
      "displayName": "Marzena Bielecka",
      "email": "marzena@evf.com.pl",
      "country": "Poland",
      "category": "Investor",
      "company": "Experior Venture Fund"
  },
  {
      "firstname": "Anna",
      "lastname": "Wnuk-Blazejczyk",
      "displayName": "Anna Wnuk-Blazejczyk",
      "email": "anna@evf.com.pl",
      "country": "Poland",
      "category": "Investor",
      "company": "Experior Venture Fund"
  },
  {
      "firstname": "Kestutis",
      "lastname": "Morkunas",
      "displayName": "Kestutis Morkunas",
      "email": "kestutis.morkunas@gmail.com",
      "country": "Lithuania",
      "category": "Public organisation",
      "company": "Vilnius Tech Park"
  },
  {
      "firstname": "Karel",
      "lastname": "Huk",
      "displayName": "Karel Huk",
      "email": "karel.huk@dex-ic.com",
      "country": "Czechia",
      "category": "Research center",
      "company": "DEX Innovation Centre"
  },
  {
      "firstname": "Debora",
      "lastname": "Santo",
      "displayName": "Debora Santo",
      "email": "deborasanto13@gmail.com",
      "country": "Serbia",
      "category": "Corporate",
      "company": "Typhoon HIL"
  },
  {
      "firstname": "Dominik",
      "lastname": "Zalewski",
      "displayName": "Dominik Zalewski",
      "email": "dominik@urbanimpact.eu",
      "country": "Germany",
      "category": "Investor",
      "company": "Urban Impact"
  },
  {
      "firstname": "Akif",
      "lastname": "Ak",
      "displayName": "Akif Ak",
      "email": "akifak78@icloud.com",
      "country": "Türkiye",
      "category": "Corporate",
      "company": "AES Akıllı Enerji Sistemleri Ltd"
  },
  {
      "firstname": "Olivier",
      "lastname": "Chabilan",
      "displayName": "Olivier Chabilan",
      "email": "ochabilan@yahoo.com",
      "country": "Estonia",
      "category": "Start-up or scale-up",
      "company": "Nobe Cars"
  },
  {
      "firstname": "antoine",
      "lastname": "boelen",
      "displayName": "antoine boelen",
      "email": "antoine.boelen@innoenergy.com",
      "country": "Netherlands",
      "category": "Investor",
      "company": "InnoEnergy"
  },
  {
      "firstname": "Paweł",
      "lastname": "Winiarski",
      "displayName": "Paweł Winiarski",
      "email": "winiarss@gmail.com",
      "category": "University",
      "company": "Warsaw University of Technology"
  },
  {
      "firstname": "Brandon",
      "lastname": "Vargas",
      "displayName": "Brandon Vargas",
      "email": "brandonvargasv@gmail.com",
      "country": "Colombia",
      "category": "Students and learners",
      "company": "InnoEnergy"
  },
  {
      "firstname": "Zoltan",
      "lastname": "Varga",
      "displayName": "Zoltan Varga",
      "email": "vargazoltanfrt@gmail.com",
      "category": "Students and learners",
      "company": "Freelancer"
  },
  {
      "firstname": "Zoltan",
      "lastname": "Csipai",
      "displayName": "Zoltan Csipai",
      "email": "zoltan.csipai@gmail.com",
      "country": "Hungary",
      "category": "Start-up or scale-up",
      "company": "Nanobubbles Europe"
  },
  {
      "firstname": "İlhan",
      "lastname": "Aytutuldu",
      "displayName": "İlhan Aytutuldu",
      "email": "iaytutu1@gmail.com",
      "category": "University",
      "company": "Gebze Teknik Üniversitesi"
  },
  {
      "firstname": "Gökhan",
      "lastname": "Öner",
      "displayName": "Gökhan Öner",
      "email": "gokhanoner@windowslive.com",
      "country": "Türkiye",
      "category": "University",
      "company": "Beykent üniversitesi"
  },
  {
      "firstname": "Osman",
      "lastname": "Oshayta",
      "displayName": "Osman Oshayta",
      "email": "oshayta@gmail.com",
      "country": "Turkey",
      "category": "Investor",
      "company": "Osha law"
  },
  {
      "firstname": "Bernadett",
      "lastname": "Lukovszki",
      "displayName": "Bernadett Lukovszki",
      "email": "lukovszki.bernadett@fhcafe.hu",
      "country": "Hungary",
      "category": "Press and media",
      "company": "FleishmanHillard Café"
  },
  {
      "firstname": "Zoltan",
      "lastname": "Fischer",
      "displayName": "Zoltan Fischer",
      "email": "zoltan.fischer@leap15.com",
      "country": "Hungary",
      "category": "Start-up or scale-up",
      "company": "Leap"
  },
  {
      "firstname": "ahu",
      "lastname": "serter",
      "displayName": "ahu serter",
      "email": "serter.ahu@gmail.com",
      "country": "Turkey",
      "category": "Investor",
      "company": "farklabs"
  },
  {
      "firstname": "Hikmet",
      "lastname": "Anıl",
      "displayName": "Hikmet Anıl",
      "email": "iyibidunya@gmail.com",
      "country": "Turkey",
      "category": "Students and learners",
      "company": "--"
  },
  {
      "firstname": "Onur",
      "lastname": "Erbay",
      "displayName": "Onur Erbay",
      "email": "onur@naviga.vc",
      "category": "Investor",
      "company": "Naviga Capital"
  },
  {
      "firstname": "Duran",
      "lastname": "Cesur",
      "displayName": "Duran Cesur",
      "email": "duran@vincivc.com",
      "country": "United Kingdom",
      "category": "Investor",
      "company": "Vinci Venture Capital"
  },
  {
      "firstname": "sadık",
      "lastname": "köseoğlu",
      "displayName": "sadık köseoğlu",
      "email": "sadik.koseoglu@sirketortagim.com",
      "country": "Türkiye",
      "category": "Investor",
      "company": "ŞirketOrtağım Melek Yatırımcı Ağı"
  },
  {
      "firstname": "Muhammad",
      "lastname": "Ibrahim",
      "displayName": "Muhammad Ibrahim",
      "email": "geo.muhammadibrahim@gmail.com",
      "country": "Egypt",
      "category": "Students and learners",
      "company": "Cairo University"
  },
  {
      "firstname": "Ali",
      "lastname": "OVALICEYLAN",
      "displayName": "Ali OVALICEYLAN",
      "email": "aliovaliceylan@gmail.com",
      "country": "Türkiye",
      "category": "Start-up or scale-up",
      "company": "Hayalimdeki Çiftliğim"
  },
  {
      "firstname": "Zoltán",
      "lastname": "Gabnai",
      "displayName": "Zoltán Gabnai",
      "email": "zoltangabnai@gmail.com",
      "country": "Hungary",
      "category": "University",
      "company": "UD"
  },
  {
      "firstname": "Vassilis",
      "lastname": "Papakonstantinou",
      "displayName": "Vassilis Papakonstantinou",
      "email": "vpap@mitefgreece.org",
      "country": "Greece",
      "category": "Investor",
      "company": "MITEF Greece"
  },
  {
      "firstname": "Julija",
      "lastname": "Maslinskaite",
      "displayName": "Julija Maslinskaite",
      "email": "julija.maslinskaite@ssmtp.lt",
      "country": "Lithuania",
      "category": "Public organisation",
      "company": "Sunrise Valley STP"
  },
  {
      "firstname": "Łukasz",
      "lastname": "Frydrych",
      "displayName": "Łukasz Frydrych",
      "email": "lukasz.frydrych@gmail.com",
      "category": "Start-up or scale-up",
      "company": "Smarthink"
  },
  {
      "firstname": "Anastasia",
      "lastname": "Sakkoula",
      "displayName": "Anastasia Sakkoula",
      "email": "sakkoula@kinno.eu",
      "country": "Greece",
      "category": "Corporate",
      "company": "KiNNO Consultants Ltd."
  },
  {
      "firstname": "Guido",
      "lastname": "Wolf",
      "displayName": "Guido Wolf",
      "email": "g.wolf@zabolis.com",
      "category": "Investor",
      "company": "Zabolis Partners"
  },
  {
      "firstname": "Simas",
      "lastname": "Banys",
      "displayName": "Simas Banys",
      "email": "banyssimas@gmail.com",
      "category": "Start-up or scale-up",
      "company": "Algarium"
  },
  {
      "firstname": "Olga",
      "lastname": "Petrova",
      "displayName": "Olga Petrova",
      "email": "pimeko@mail.ru",
      "category": "Start-up or scale-up",
      "company": "Pimeko"
  },
  {
      "firstname": "Alexandru",
      "lastname": "Pascu",
      "displayName": "Alexandru Pascu",
      "email": "alexandru.pascu99@gmail.com",
      "category": "Students and learners",
      "company": "UPB"
  },
  {
      "firstname": "Bogdan",
      "lastname": "Dumitrache",
      "displayName": "Bogdan Dumitrache",
      "email": "bogdan.dumitrache@relians.ro",
      "country": "Romania",
      "category": "Corporate",
      "company": "RELIANS CORP"
  },
  {
      "firstname": "Sorina",
      "lastname": "Stoica",
      "displayName": "Sorina Stoica",
      "email": "sorina.a.stoica@gmail.com",
      "country": "Romania",
      "category": "Corporate",
      "company": "Actual Connect"
  },
  {
      "firstname": "Tibor",
      "lastname": "Hodik",
      "displayName": "Tibor Hodik",
      "email": "tibor.hodik@progressive.hu",
      "country": "Hungary",
      "category": "Press and media",
      "company": "Progressive"
  },
  {
      "firstname": "Catalin",
      "lastname": "Iordache",
      "displayName": "Catalin Iordache",
      "email": "catalin.iordache86@gmail.com",
      "country": "Romania",
      "category": "Investor",
      "company": "Vizal"
  },
  {
      "firstname": "Marius",
      "lastname": "Bendorfean",
      "displayName": "Marius Bendorfean",
      "email": "bndrfn@yahoo.com",
      "country": "Romania",
      "category": "Corporate",
      "company": "Elsaco"
  },
  {
      "firstname": "Octavian",
      "lastname": "Georgescu",
      "displayName": "Octavian Georgescu",
      "email": "octavian.georgescu@gmail.com",
      "country": "Romania",
      "category": "Investor",
      "company": "Octavian"
  },
  {
      "firstname": "Cristina",
      "lastname": "Iliescu",
      "displayName": "Cristina Iliescu",
      "email": "pintilie.cristina.maria@gmail.com",
      "category": "Corporate",
      "company": "Oracle"
  },
  {
      "firstname": "Mariana",
      "lastname": "Dolhascu",
      "displayName": "Mariana Dolhascu",
      "email": "dolhascu.mariana@gmail.com",
      "country": "Romania",
      "category": "Investor",
      "company": "Expert Contabil Dolhascu Ro.RO"
  },
  {
      "firstname": "Pranay",
      "lastname": "Kasturi",
      "displayName": "Pranay Kasturi",
      "email": "pranaykasturi@gmail.com",
      "category": "University",
      "company": "Univeristy of Oldenburg"
  },
  {
      "firstname": "Tamoor",
      "lastname": "Ali",
      "displayName": "Tamoor Ali",
      "email": "t.ali@tue.nl",
      "country": "Netherlands",
      "category": "University",
      "company": "TU/e"
  },
  {
      "firstname": "Neluța",
      "lastname": "DUINĂ",
      "displayName": "Neluța DUINĂ",
      "email": "neliduina@yhoo.com",
      "country": "Roumania",
      "category": "Public organisation",
      "company": "CNAIR S. A."
  },
  {
      "firstname": "İbrahim",
      "lastname": "BULDU",
      "displayName": "İbrahim BULDU",
      "email": "eemibrahimbuldu@gmail.com",
      "country": "TURKEY",
      "category": "Students and learners",
      "company": "RTEU"
  },
  {
      "firstname": "Goanta",
      "lastname": "Alina",
      "displayName": "Goanta Alina",
      "email": "deedee_fun@yahoo.com",
      "country": "Romania",
      "category": "Start-up or scale-up",
      "company": "GoantaAlinaOana"
  },
  {
      "firstname": "Maciej",
      "lastname": "Jakaczyński",
      "displayName": "Maciej Jakaczyński",
      "email": "mefju403@gmail.com",
      "country": "Polska",
      "category": "Investor",
      "company": "freelance"
  },
  {
      "firstname": "Candra",
      "lastname": "Saigustia",
      "displayName": "Candra Saigustia",
      "email": "saigustia@gmail.com",
      "country": "Poland",
      "category": "Students and learners",
      "company": "Warsaw University of Technology"
  },
  {
      "firstname": "Gala",
      "lastname": "Maturana",
      "displayName": "Gala Maturana",
      "email": "gala.maturana@eitmanufacturing.eu",
      "country": "Spain",
      "category": "Public organisation",
      "company": "EIT Manufacturing"
  },
  {
      "firstname": "Liviu",
      "lastname": "Zburatura",
      "displayName": "Liviu Zburatura",
      "email": "liviu.zburatura@maelstromgroup.eu",
      "country": "Romania",
      "category": "Corporate",
      "company": "Maelstrom Invrstment Group"
  },
  {
      "firstname": "Zampia",
      "lastname": "Kalogridi",
      "displayName": "Zampia Kalogridi",
      "email": "kalogridi@pleione-energy.com",
      "country": "Greece",
      "category": "Start-up or scale-up",
      "company": "Pleione Energy S.A"
  },
  {
      "firstname": "Piotr",
      "lastname": "Gladysz",
      "displayName": "Piotr Gladysz",
      "email": "piotr.gladysz93@gmail.com",
      "country": "Poland",
      "category": "Corporate",
      "company": "Grupa Azoty PKCh"
  },
  {
      "firstname": "Cristina",
      "lastname": "Murariu",
      "displayName": "Cristina Murariu",
      "email": "murariucristina@gmail.com",
      "category": "Press and media",
      "company": "P"
  },
  {
      "firstname": "Ramona",
      "lastname": "Rusu",
      "displayName": "Ramona Rusu",
      "email": "rusuramona2003@gmail.com",
      "country": "Romania",
      "category": "Corporate",
      "company": "Dacian petroleum srl"
  },
  {
      "firstname": "Vladana",
      "lastname": "Ajvaz",
      "displayName": "Vladana Ajvaz",
      "email": "vladana.ajvaz@gmail.com",
      "country": "Serbia",
      "category": "Public organisation",
      "company": "world bank"
  },
  {
      "firstname": "Bulent",
      "lastname": "Yilmaz",
      "displayName": "Bulent Yilmaz",
      "email": "bulylmz@gmail.com",
      "country": "Turkey",
      "category": "Corporate",
      "company": "Liberro"
  },
  {
      "firstname": "Sedat",
      "lastname": "Görmüş",
      "displayName": "Sedat Görmüş",
      "email": "sedatgormus@mavialp.com",
      "country": "Turkey",
      "category": "Start-up or scale-up",
      "company": "Mavi Alp Bilgi Teknolojileri Tic. Ltd. Şti."
  },
  {
      "firstname": "Krisztina",
      "lastname": "Verbics",
      "displayName": "Krisztina Verbics",
      "email": "krisztina.verbics@itm.gov.hu",
      "country": "Hungary",
      "category": "Public organisation",
      "company": "Ministry for Innovation and Technology"
  },
  {
      "firstname": "Gamze",
      "lastname": "Akarsu",
      "displayName": "Gamze Akarsu",
      "email": "gamzeakarsu.en@gmail.com",
      "country": "Turkey",
      "category": "Public organisation",
      "company": "UNDP"
  },
  {
      "firstname": "Youssef",
      "lastname": "Nabelsi",
      "displayName": "Youssef Nabelsi",
      "email": "youssef.nabulsi@ieee.org",
      "country": "Turkey",
      "category": "University",
      "company": "Engineering management master's student"
  },
  {
      "firstname": "Adina",
      "lastname": "Sandu",
      "displayName": "Adina Sandu",
      "email": "office@repom.ro",
      "country": "Romania",
      "category": "Corporate",
      "company": "Repom"
  },
  {
      "firstname": "Joanna",
      "lastname": "Landsvig",
      "displayName": "Joanna Landsvig",
      "email": "jojolanding@gmail.com",
      "category": "Research center",
      "company": "Nordic Analytics"
  },
  {
      "firstname": "Luis",
      "lastname": "Ayora",
      "displayName": "Luis Ayora",
      "email": "luisalbertoayora@hotmail.com",
      "category": "Investor",
      "company": "Anpco"
  },
  {
      "firstname": "Levente",
      "lastname": "Gyorgy",
      "displayName": "Levente Gyorgy",
      "email": "levygyorgy@gmail.com",
      "country": "Romania",
      "category": "Start-up or scale-up",
      "company": "Levy Construct"
  },
  {
      "firstname": "Ivan",
      "lastname": "Stancetic",
      "displayName": "Ivan Stancetic",
      "email": "ivanfarmnet@gmail.com",
      "country": "Serbia",
      "category": "Start-up or scale-up",
      "company": "Farmnet"
  }
]